import React from 'react';

import logo from '@/assets/Logo.svg';

const Footer: React.FC = () => {
  return (
    <footer className="relative mt-24 overflow-hidden border-t border-border bg-card sm:mt-12">
      <svg
        className="absolute -bottom-20 start-1/2 w-full -translate-x-1/2 transform"
        width="2745"
        height="488"
        viewBox="0 0 2745 488"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0.5 330.864C232.505 403.801 853.749 527.683 1482.69 439.719C2111.63 351.756 2585.54 434.588 2743.87 487"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 308.873C232.505 381.81 853.749 505.692 1482.69 417.728C2111.63 329.765 2585.54 412.597 2743.87 465.009"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 286.882C232.505 359.819 853.749 483.701 1482.69 395.738C2111.63 307.774 2585.54 390.606 2743.87 443.018"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 264.891C232.505 337.828 853.749 461.71 1482.69 373.747C2111.63 285.783 2585.54 368.615 2743.87 421.027"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 242.9C232.505 315.837 853.749 439.719 1482.69 351.756C2111.63 263.792 2585.54 346.624 2743.87 399.036"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 220.909C232.505 293.846 853.749 417.728 1482.69 329.765C2111.63 241.801 2585.54 324.633 2743.87 377.045"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 198.918C232.505 271.855 853.749 395.737 1482.69 307.774C2111.63 219.81 2585.54 302.642 2743.87 355.054"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 176.927C232.505 249.864 853.749 373.746 1482.69 285.783C2111.63 197.819 2585.54 280.651 2743.87 333.063"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 154.937C232.505 227.873 853.749 351.756 1482.69 263.792C2111.63 175.828 2585.54 258.661 2743.87 311.072"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 132.946C232.505 205.882 853.749 329.765 1482.69 241.801C2111.63 153.837 2585.54 236.67 2743.87 289.082"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 110.955C232.505 183.891 853.749 307.774 1482.69 219.81C2111.63 131.846 2585.54 214.679 2743.87 267.091"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 88.9639C232.505 161.901 853.749 285.783 1482.69 197.819C2111.63 109.855 2585.54 192.688 2743.87 245.1"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 66.9729C232.505 139.91 853.749 263.792 1482.69 175.828C2111.63 87.8643 2585.54 170.697 2743.87 223.109"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 44.9819C232.505 117.919 853.749 241.801 1482.69 153.837C2111.63 65.8733 2585.54 148.706 2743.87 201.118"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 22.991C232.505 95.9276 853.749 219.81 1482.69 131.846C2111.63 43.8824 2585.54 126.715 2743.87 179.127"
          className="stroke-border/40"
          stroke="currentColor"
        />
        <path
          d="M0.5 1C232.505 73.9367 853.749 197.819 1482.69 109.855C2111.63 21.8914 2585.54 104.724 2743.87 157.136"
          className="stroke-border/40"
          stroke="currentColor"
        />
      </svg>
      <div className="relative z-10">
        <div className="mx-auto mb-10 grid grid-cols-2 gap-6 px-[15%] pt-10 md:grid-cols-4 lg:grid-cols-5 lg:pt-20">
          <div className="col-span-full hidden lg:col-span-1 lg:block">
            <a
              className="flex-none text-xl font-semibold"
              href="/index"
              aria-label="SCL"
            >
              <img className="h-6 w-auto" src={logo} alt="SCL Logo" />
            </a>
            <p className="mt-3 text-xs text-gray-300 dark:text-gray-400 sm:text-sm">
              © 2021-2025 SCL AB
            </p>
            <p className="text-blue mt-5">
              SCL is an esport event organizer and team practice platform.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase ">Social Media</h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://twitter.com/scleague_net"
                  rel="noreferrer"
                >
                  X (Twitter)
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://twitch.tv/scleague_net"
                  rel="noreferrer"
                >
                  Twitch
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://www.instagram.com/scleague_net/"
                  rel="noreferrer"
                >
                  Instagram
                </a>
              </p>

              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://www.youtube.com/@scl7173"
                  rel="noreferrer"
                >
                  Youtube
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase ">Contact</h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="mailto:support@scl.gg"
                >
                  General inquiries
                </a>
              </p>
            </div>

            <h4 className="mt-7 text-xs font-semibold uppercase ">
              Help Center
            </h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://help.scl.gg/"
                  rel="noreferrer"
                >
                  Help & Docs
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://discord.gg/kvJt68Wutk"
                  rel="noreferrer"
                >
                  Discord
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase ">Useful links</h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/scrim"
                >
                  Scrims
                </a>
              </p>
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/league"
                >
                  Leagues
                </a>
              </p>
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/team-finder"
                >
                  Team finder
                </a>
              </p>
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/leaguerules"
                >
                  League rules
                </a>
              </p>
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/worldranking"
                >
                  Valve World Ranking
                </a>
              </p>
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase ">Portfolio</h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://www.hltv.org/events/7185/scl-season-9"
                >
                  HLTV
                </a>
              </p>
              <p>
                <a
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://liquipedia.net/counterstrike/SCL/Season_9/Challenger_Division"
                >
                  Liquipedia
                </a>
              </p>
            </div>

            <h4 className="mt-7 text-xs font-semibold uppercase ">Partners</h4>

            <div className="mt-3 grid space-y-3 text-sm">
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://grid.gg/"
                  rel="noreferrer"
                >
                  GRID
                </a>
              </p>
              <p>
                <a
                  target="_blank"
                  className="text-blue hover: inline-flex gap-x-2 text-muted-foreground"
                  href="https://dathost.net"
                  rel="noreferrer"
                >
                  DatHost
                </a>
              </p>
            </div>
          </div>
        </div>

        <div className="mx-auto px-4 pb-10 pt-5 sm:px-[15%] lg:px-[15%] lg:pb-20">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div className="flex items-center gap-x-3">
              <div className="ml-0 space-x-4 text-sm">
                <a
                  className="hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/terms"
                >
                  Terms of Use
                </a>
                <a
                  className="hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/privacy"
                >
                  Privacy Policy
                </a>
                <a
                  className="hover: inline-flex gap-x-2 text-muted-foreground"
                  href="/cookies"
                >
                  Cookie Policy
                </a>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <div className="mt-3 sm:hidden">
                <a
                  className="flex-none text-xl font-semibold "
                  href="/index"
                  aria-label="SCL"
                >
                  <img className="h-6 w-auto" src={logo} alt="SCL Logo" />
                </a>
                <p className="mt-1 text-xs text-muted-foreground sm:text-sm">
                  © 2021-2025 SCL AB
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
